import React from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';
/**
 * styled components generates an actual stylesheet with classes,
and attaches those classes to the DOM nodes of styled components
via the className prop.
It injects the generated stylesheet at the end of the head of the document during runtime
 */

const PrintHeader = styled.div.withConfig({
  displayName: "WidgetPrintHeader__PrintHeader",
  componentId: "r44wil-0"
})(["border:0.2em solid;border-color:", ";display:flex;justify-content:center;margin:3rem 1rem 1rem 1rem;text-transform:uppercase;letter-spacing:0.0625em;font-weight:normal;color:", ";@media print{border-color:", ";color:", ";}"], props => props.theme.palette.text.primary, props => props.theme.palette.text.primary, props => props.theme.palette.common.black, props => props.theme.palette.common.black);
export const WidgetPrintHeader = ({
  title
}) => /*#__PURE__*/React.createElement(PrintHeader, {
  className: "widget-print-header"
}, /*#__PURE__*/React.createElement(Typography, {
  variant: "h5",
  className: "widget-print-h5"
}, title));
export default WidgetPrintHeader;